import React from 'react';
import AlumniHero from './AlumniHero';
import './Alumni.css';
import AlumniCard from './AlumniCard';

function Membership() {
  return (
    <div>
      <AlumniHero />
      <AlumniCard />
    </div>
  );
};

export default Membership;